import { createThunk } from '@rootstrap/redux-tools';

import membershipService from 'services/membershipService';
import parseError from 'utils/parseError';

export const createMembership = createThunk(
  'CREATE_MEMBERSHIP',
  async (celebrityId, membershipId, creditCardId) => {
    try {
      const membership = await membershipService.createMembership(
        celebrityId,
        membershipId,
        creditCardId
      );
      return membership;
    } catch ({ response }) {
      throw parseError(response);
    }
  }
);

export const cancelMembership = createThunk(
  'CANCEL_MEMBERSHIP',
  async (celebrityId, membershipId) => {
    try {
      await membershipService.cancelMembership(celebrityId, membershipId);
    } catch ({ response }) {
      throw parseError(response);
    }
  }
);

export const cancelEventSubscription = createThunk(
  'CANCEL_EVENT_SUBSCRIPTION',
  async (eventId) => {
    try {
      await membershipService.cancelEventSubscription(eventId);
    } catch ({ response }) {
      throw parseError(response);
    }
  }
);

export const buyEpisode = createThunk('BUY_EPISODE', async params => {
  try {
    await membershipService.buyEpisode(params);
  } catch ({ response }) {
    throw parseError(response);
  }
});

export const buyPodcast = createThunk('BUY_PODCAST', async params => {
  try {
    await membershipService.buyPodcast(params);
  } catch ({ response }) {
    throw parseError(response);
  }
});

export const subscribeAndBuyEpisode = createThunk(
  'SUBSCRIBE_AND_BUY_EPISODE',
  async (celebrityId, membershipPlanId, creditCardId, episodeId) => {
    try {
      const membership = await membershipService.createMembership(
        celebrityId,
        membershipPlanId,
        creditCardId
      );
      await membershipService.buyEpisode({ episodeId, creditCardId });
      return membership;
    } catch ({ response }) {
      throw parseError(response);
    }
  }
);

export const subscribeAdTier = createThunk(
  'SUBSCRIBE_AD_TIER',
  async (celebrityId, membershipPlanId, creditCardId) => {
    try {
      const membership = await membershipService.subscribeadtier(
        celebrityId,
        creditCardId,
        membershipPlanId
      );
      return membership;
    } catch ({ response }) {
      throw parseError(response);
    }
  }
);

export const registerEvent = createThunk('REGISTER_EVENT', async (creditCardId, eventId, register) => {
  try {
    const membership = await membershipService.registerEvent(creditCardId, eventId, register);
    return membership;
  } catch ({ response }) {
    throw parseError(response);
  }
});
